import type { LocationSectorsTabProps } from "./location-sectors-tab.type";

import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { LOCATIONS_FILTERS } from "@/entities/locations";
import LocationAddButton from "@/modules/location/location-add-button";
import LocationsListProvider from "@/modules/locations/locations-list-provider";
import LocationsListTable from "@/modules/locations/locations-list-table";

const LocationSectorsTab = ({ location, loading }: LocationSectorsTabProps) => {
  const locationId = location?.id ?? null;
  const enabled = !!locationId;

  const extraActions = location ? (
    <LocationAddButton parentLocation={location} shortButtonText />
  ) : undefined;

  return (
    <LocationsListProvider
      loading={loading}
      enabled={enabled}
      storageKey={STORAGE_KEYS.LOCATIONS_SECTORS}
      hiddenFilters={{ [LOCATIONS_FILTERS.LOCATION_ID]: locationId }}
    >
      <LocationsListTable isSectorsTable extraActions={extraActions} />
    </LocationsListProvider>
  );
};

export default LocationSectorsTab;
